export default __webpack_public_path__ + "static/farmhouse_bunker-0d47229cf47d57add84a5999d7f25adf.png";